<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "você deseja que a limpeza seja"
    }
  },

  computed: {
    ...mapState("newOrder", ["to_be"])
  },

  methods: {
    ...mapActions("newOrder", ["setToBe"])
  }
};
</script>

<template>
  <div id="tobe" class="section">
    <div class="section-title">
      {{ title }}
      <hr />
    </div>

    <div class="section-body">
      <div
        class="btn bg-pink"
        :class="{
          'bg-pink': to_be !== 'professional',
          'bg-gray': to_be === 'professional'
        }"
        @click="
          setToBe('schedule');
          $emit('scrollTo', '#PerSchedule');
        "
      >
        em um dia específico
      </div>

      <div
        class="btn"
        :class="{
          'bg-pink': to_be !== 'schedule',
          'bg-gray': to_be === 'schedule'
        }"
        @click="
          setToBe('professional');
          $emit('scrollTo', '#PerProfessional');
        "
      >
        com um profissional favorito
      </div>
    </div>
  </div>
</template>

<style scoped>
.section-body {
  width: 460px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.btn {
  flex: 1;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .section-body {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .btn {
    padding: 8px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/ToBe.vue